PJQ.views.budget.TaxCodeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'tax-code-settings')
    },
    events: {
        'click .btn-pull-erp': 'pullERP',
        'click .btn-add-tax-code': 'addClicked',
        'click .btn-edit-tax-code': 'editClicked',
        'click .btn-delete-tax-code': 'deleteClicked'
    },
    beforeFirstRender: function () {
        this.isFetched = false;
        PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
            this.erpIntegration = erp;
            PJQ.app.session.fetchTaxCodes(_.bind(function (taxCodes) {
                this.taxCodes = taxCodes;

                this.isFetched = true;
                this.render();
            }, this));
        }, this));
        return false;
    },
    renderData: function () {
        return {
            project: this.options.project,
            taxCodes: this.taxCodes,
            isFetched: this.isFetched,
            erpIntegration: this.erpIntegration
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }
        this.renderTaxCodeTable();
        this.renderERP();
    },
    renderTaxCodeTable: function () {
        if (this.dataTable && this.dataTable.dataTable) {
            this.dataTable.dataTable.destroy();
            this.dataTable = null;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".tax-codes-table"),
            data: this.taxCodes.models,
            order: [1, 'asc'],
            onRowDoubleClick: _.bind(function (row) {
                this.editTaxCode(row.data());
            }, this),
            rowId: 'cid',
            paging: false,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.editTaxCode(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            return false;
                        },
                        onClick: (row) => {
                            this.deleteTaxCode(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "title": "",
                    "data": "attributes.externalObject",
                    "width": "5%",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": (data, type, row) => {
                        if (data) {
                            return '<i class="fas fa-link-simple fs-14 text-success" title="Synced to ERP"></i>';
                        }
                        return '';
                    }
                },
                {
                    "data": "attributes.code",
                    "title": "Code",
                    "width": "15%"
                },
                {
                    "data": "attributes.description",
                    "title": "Description"
                },
                {
                    "data": "attributes.rate",
                    "title": "Rate",
                    "render": (data, type, model) => {
                        return PJQ.helpers.formatHelpers.formatPercent(data/100);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "className": "p-2",
                    "width": "80px",
                    "render": (data, type, model) => {
                        let canDelete = false,
                            res = '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-edit-tax-code ml-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        if (canDelete) {
                            res += '<button type="button" class="btn btn-danger btn-delete-tax-code ml-1 fs-14"><span class="fal fa-trash"></span></button>';
                        } else {
                            // res += '<button type="button" disabled class="btn btn-danger ml-1 fs-14" title="This cost code has associated budget line items"><span class="fal fa-trash"></span></button>';
                        }
                        return res + '</div>';
                    }
                }
            ],
            language: {
                zeroRecords: 'Click "Add Tax Code" to create a new Tax Code'
            }
        });
    },
    addClicked: function () {
        this.editTaxCode(null);
    },
    editClicked: function (e) {
        let id = $(e.currentTarget).closest('tr').attr('id');
        if (_.size(id) > 0) {
            let taxCode = this.taxCodes.get(id);
            if (taxCode != null) {
                this.editTaxCode(taxCode);
            }
        }
    },
    editTaxCode: function (taxCode) {
        new PJQ.views.budget.EditTaxCodeModal({
            model: taxCode,
            project: this.options.project,
            onSave: _.bind(function (taxCode) {
                this.taxCodes.add(taxCode);
                this.render();
            }, this),
            onDelete: _.bind(function (taxCode) {
                if (taxCode.id > 0) {
                    this.deleteTaxCode(taxCode, false);
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('tr').attr('id'),
            taxCode = this.taxCodes.get(cid);
        this.deleteTaxCode(taxCode);
    },
    deleteTaxCode: function (taxCode, showDialogue = true) {
        if(showDialogue) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this Tax Code?",
                onDelete: _.bind(function () {
                    taxCode.destroy({
                        notify: false,
                        success: _.bind(function () {
                            this.taxCodes.remove(taxCode);
                            this.render();
                        }, this)
                    });
                }, this)
            });
        }
        else{
            taxCode.destroy({
                notify: false,
                success: _.bind(function () {
                    this.taxCodes.remove(taxCode);
                    this.render();
                }, this)
            });
        }
    },
    renderERP: function () {
        if (this.erpIntegration == null) {
            return;
        }

        PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            pushSupported: false,
            pullSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMPANY_TAX_CODES),
            status: PJQ.constants.integrations.erp.syncStatuses.SYNCED
        });

        let badge = PJQ.helpers.erp.getERPBadge(status);
        this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
    },
    pullERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMPANY_TAX_CODES)) {
            this.erpIntegration.pullTaxCodes(this.options.project, (newTaxCodes, err) => {
                if(newTaxCodes == null){
                    return;
                }

                this.taxCodes.reset(newTaxCodes);
                PJQ.notifications.notify.successNotify({
                    message: _.size(newTaxCodes).toString() + ' Tax Codes pulled from ERP'
                });
                this.render();
            });
        }
    }
});

PJQ.views.budget.EditTaxCodeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-tax-code'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.budget.TaxCode({
                projectId: this.options.project ? this.options.project.id : null,
                rate: 0
            });
        }

        this.isFetched = true;
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input',
                'select'
            ]
        });

        this.$(".input-name").inputmask({
            "mask": "a".repeat(50),
            placeholder: "",
            definitions: {
                'a': {
                    validator: ".",
                    cardinality: 1
                }
            }
        });

        this.$(".input-code").inputmask({
            "mask": "a".repeat(20),
            placeholder: "",
            definitions: {
                'a': {
                    validator: "[0-9a-zA-Z]",
                    cardinality: 1
                }
            }
        });

        PJQ.helpers.inputHelpers.inputMaskPercent(this.$('.input-percent'), 2, true);
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        let isValid = true;

        let $code = this.$('.input-code');
        PJQ.helpers.inputHelpers.setInputError($code, true);
        if (this.model.get('code') == null || this.model.get('code').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($code, false);
            isValid = false;
        }

        return isValid;
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Tax Code saved'
                    });
                }, this)
            });
        }
    },
    delete: function () {
        if (typeof this.options.onDelete === 'function') {
            this.options.onDelete(this.model);
        }
        this.removeModal();
    }
});